import { PaidDayOfWeek, PaidTimeRange } from "../payment-zone-area.type";
import { DAYS_OF_WEEK, PAID_TIME_RANGE_SHORTCUTS } from "../parking-payment.const";

export const usePaidTimeRanges = (value: PaidTimeRange[], onChange: (ranges: PaidTimeRange[]) => void) => {
  const sortByDay = (ranges: PaidTimeRange[]) =>
    [...ranges].sort((a, b) => {
      const ai = DAYS_OF_WEEK.findIndex((d) => d.value === a.day);
      const bi = DAYS_OF_WEEK.findIndex((d) => d.value === b.day);
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
    });

  const applyShortcut = (ranges: PaidTimeRange[]) => {
    onChange(sortByDay([...value, ...ranges]));
  };

  const addDay = (day: PaidDayOfWeek) => {
    onChange(sortByDay([...value, { day, startTime: "09:00", endTime: "19:00" }]));
  };

  const updateRange = (index: number, field: Exclude<keyof PaidTimeRange, "day">, val: string) => {
    const updated = [...value];
    updated[index] = { ...updated[index], [field]: val };
    onChange(updated);
  };

  const removeRange = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const availableDays = DAYS_OF_WEEK.filter((d) => !value.some((r) => r.day === d.value));

  const getDayLabel = (day: PaidDayOfWeek) => DAYS_OF_WEEK.find((d) => d.value === day)?.label ?? day;

  const shortcuts = PAID_TIME_RANGE_SHORTCUTS;

  return { applyShortcut, addDay, updateRange, removeRange, availableDays, getDayLabel, shortcuts };
};
